export default __webpack_public_path__ + "static/media/ezgif.com-gif-maker2.389f3759.gif";